import React from 'react';
import { Link } from 'react-router-dom';
import QRCode from '../../assets/images/qr_code.png';
import PlayStore from '../../assets/icons/play-store.svg';
import AppsStore from '../../assets/icons/apps-store.svg';

// Import Icon Sosmed as Componen
import { ReactComponent as IconInstagram } from '../../assets/icons/icon-awesome-instagram.svg';
import { ReactComponent as IconFacebook } from '../../assets/icons/icon-awesome-facebook.svg';
import { ReactComponent as IconYoutube } from '../../assets/icons/icon-awesome-youtube.svg';
const FooterHome = () => {
  return (
    <>
      <div className="bg-white w-full flex py-20">
        <div className="max-w-screen-xl mx-auto lg:px-12 w-full flex">
          <div className=" w-4/12">
            <div className="flex flex-col">
              <p className="text-xs capitalize opacity-75 mb-2">BISNIS</p>
              <Link to="/partner">
                <p className="text-font-gray font-semibold ">
                  Menjadi Media Partner
                </p>
              </Link>
              <Link to="/business-partner">
                <p className="text-font-gray font-semibold ">
                  Belanja untuk bisnis Anda
                </p>
              </Link>
            </div>
            <div className="flex flex-col mt-16">
              <p className="text-xs capitalize opacity-75 mb-2">BANTUAN</p>
              <Link to="/help">
                <p className="text-font-gray font-semibold ">Pusat Bantuan</p>
              </Link>
              <Link to="/terms">
                <p className="text-font-gray font-semibold ">
                  Syarat & Ketentuan
                </p>
              </Link>
              <Link to="/privacy">
                <p className="text-font-gray font-semibold ">
                  Kebijakan Privasi
                </p>
              </Link>
            </div>
          </div>
          {/* Section of social media */}
          <div className="w-4/12 px-4">
            <div className="flex flex-col w-full">
              <p className="text-xs uppercase opacity-75 mb-2">ikuti kami</p>
              <div className="flex">
                <a href="https://facebook.com">
                  <div className="h-8 w-8 flex justify-center items-center mr-4">
                    <IconFacebook />
                  </div>
                </a>
                <a href="https://instagram.com/">
                  <div className="h-8 w-8 flex justify-center items-center mr-4">
                    <IconYoutube />
                  </div>
                </a>
                <a href="https://youtube.com/">
                  <div className="h-8 w-8 flex justify-center items-center mr-4">
                    <IconInstagram />
                  </div>
                </a>
              </div>
            </div>
          </div>
          {/* End of section of social media */}
          <div className="w-4/12 flex flex-col pl-4">
            <h2 className="text-basic-orange text-3xl">
              Belanja kebutuhan harianmu
            </h2>
            <p className="text-font-gray mt-1 mb-2">
              Unduh app kami dibawah ini
            </p>
            <div className="flex mt-4">
              <img src={QRCode} alt="" className="h-32 mr-6" />
              <div className="flex flex-col justify-evenly items-start">
                <a href="https://www.apple.com/app-store/">
                  <img src={AppsStore} alt="" className="h-6" />
                </a>
                <a href="https://play.google.com/store">
                  <img src={PlayStore} alt="" className="h-6" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="py-6 flex">
        <p className="text-sm text-font-gray mx-auto">
          © Agrotech 2020. Hak Cipta Dilindung
        </p>
      </div>
    </>
  );
};

export default FooterHome;
